import axios, { AxiosInstance } from "axios";
import { useContext } from "react";
import {
  BearerTokenProvider,
  UseApiConfig,
  UseApiRequest,
  UseApiResponse,
  useApi
} from "sonobello.utilities.react.axios";

import { UserContext } from "../Context/UserContext";
import { GemError } from "../Types/GemError";
import EnvironmentConfiguration from "../V2/Constants/EnvironmentConfiguration";

const buildUseGem =
  (axiosInstance: AxiosInstance) =>
  <
    TResponsePayload = undefined,
    TRequestPayload = undefined,
    TCustom = undefined,
    TResponseError extends GemError = GemError
  >(
    request?: UseApiRequest<TRequestPayload, TCustom> | UseApiRequest<TRequestPayload>,
    config?: UseApiConfig,
    requestBearerTokenProvider?: BearerTokenProvider
  ): UseApiResponse<TRequestPayload, TCustom, TResponseError, TResponsePayload> => {
    const { bearerTokenProvider } = useContext(UserContext);
    const hook = useApi<TResponsePayload, TRequestPayload, TCustom, TResponseError>({
      request: request ? { ...request, custom: (request?.custom ?? undefined) as TCustom } : request,
      config: {
        axiosInstance: axiosInstance as never,
        authProvider: requestBearerTokenProvider || bearerTokenProvider,
        isCancellable: false,
        ...config
      }
    });
    return hook;
  };

export const useGem = buildUseGem(axios.create({ baseURL: EnvironmentConfiguration.apiBaseUrl }));
